/*
  Analytische bestanddelen — zet rich-text regels om naar tabel-rijen.

  Per [data-js-analyse] blok wordt de tekst per REGEL gelezen. Regels worden
  herkend aan losse alinea's, <br> (zachte returns) én letterlijke regeleindes,
  zodat het werkt ongeacht hoe Shopify de rich text rendert.

  Per regel wordt label/waarde bepaald:
  - "Label | Waarde"  -> expliciet gesplitst op de eerste "|"
  - "Label 16,00"     -> waarde = getal/(eenheid) aan het eind van de regel
  Een regel met een waarde tussen haakjes (bv. "(%)", "(Berekend)") of een kop
  (h1-h6) krijgt de sectiekop-stijl. Een label dat met "> " begint springt in.
*/
(function () {
  var TRAILING_VALUE = /^([\s\S]*?)\s*(\([^()]*\)|[-+]?\d[\d.,]*%?)\s*$/;

  function splitRow(text) {
    var pipe = text.indexOf('|');
    if (pipe !== -1) {
      return { label: text.slice(0, pipe).trim(), value: text.slice(pipe + 1).trim() };
    }
    var match = text.match(TRAILING_VALUE);
    if (match && match[1].trim()) {
      return { label: match[1].trim(), value: match[2].trim() };
    }
    return { label: text.trim(), value: '' };
  }

  function isHeaderValue(value) {
    return /^\(.*\)$/.test(value);
  }

  // Haal de tekstregels uit een element: <br> en letterlijke \n worden splitsen.
  function lines(node) {
    var html = (node.innerHTML || '').replace(/<br\s*\/?>/gi, '\n');
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var text = (tmp.textContent || '').replace(/ /g, ' ');
    return text.split('\n');
  }

  function buildRow(label, value, isHead) {
    var indent = false;
    if (label.indexOf('>') === 0) {
      indent = true;
      label = label.replace(/^>\s*/, '');
    }

    var row = document.createElement('div');
    row.className = 'wf-analyse__row';
    if (isHead) row.className += ' wf-analyse__row--head';
    if (indent) row.className += ' wf-analyse__row--indent';

    var labelEl = document.createElement('span');
    labelEl.className = 'wf-analyse__label';
    labelEl.textContent = label;
    row.appendChild(labelEl);

    if (value) {
      var valueEl = document.createElement('span');
      valueEl.className = 'wf-analyse__value';
      valueEl.textContent = value;
      row.appendChild(valueEl);
    }

    return row;
  }

  function transform(block) {
    if (block.dataset.wfAnalyseDone) return;

    var nodes = block.querySelectorAll('h1, h2, h3, h4, h5, h6, p, li');
    var fragment = document.createDocumentFragment();

    function addNode(node, forceHead) {
      lines(node).forEach(function (line) {
        var text = line.trim();
        if (!text) return;
        var parts = splitRow(text);
        var isHead = forceHead || isHeaderValue(parts.value);
        fragment.appendChild(buildRow(parts.label, parts.value, isHead));
      });
    }

    if (nodes.length) {
      Array.prototype.forEach.call(nodes, function (node) {
        addNode(node, /^H[1-6]$/.test(node.tagName));
      });
    } else {
      addNode(block, false);
    }

    if (!fragment.childNodes.length) return;
    block.innerHTML = '';
    block.appendChild(fragment);
    block.dataset.wfAnalyseDone = '1';
  }

  function init() {
    var blocks = document.querySelectorAll('[data-js-analyse]');
    Array.prototype.forEach.call(blocks, transform);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
